import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './_styles.scss'

class LayoutThreeChannel extends Component {
  render() {
    const { groups = {} } = this.props;

    const poster1 = groups[0] || {};
    const poster2 = groups[1] || {};
    const poster3 = groups[2] || {};

    return (
      <div className="layout-three-channel">
        <div className="layout-three-channel__row-top">
          <div className='layout-three-channel__poster-medium'>
            <img 
              src={poster1.images.large} 
              alt={poster1.title} 
            />
          </div>

          <div className='layout-three-channel__poster-medium'>
            <img 
              src={poster2.images.large} 
              alt={poster2.title} 
            />
          </div>
        </div>

        <div className="layout-three-channel__row-bottom">
          <div className='layout-three-channel__poster-large'>
            <img 
              src={poster3.images.large} 
              alt={poster3.title} 
            />
          </div>
        </div>
      </div>
    );
  }
}

LayoutThreeChannel.propTypes = {
  groups: PropTypes.array,
};

LayoutThreeChannel.defaultProps = {
  groups: [],
};

export default LayoutThreeChannel;



// WEBPACK FOOTER //
// ./src/payments/DetailSelector/LandingComercialChannels/Components/LayoutThreeChannel/index.jsx